import React from 'react';
import './index.scss';
import waiting from '../../images/loading.gif';

export default function Wait({ progress }) {
  return (
    <div className="wait-root">
      <img src={waiting} alt=""/>
    </div>
  )
}